import {A4uStrokeWidth as IconComponent} from '@adobe/react-spectrum-workflow/dist/StrokeWidth.js';
import {Icon, IconPropsWithoutChildren} from '@react-spectrum/icon';
import React from 'react';

export default function StrokeWidth(props: IconPropsWithoutChildren) {
  return <Icon {...props}><IconComponent /></Icon>;
}
